import NextI18Next, { WithTranslation as WithTranslationType } from 'next-i18next'
import i18nextLocizeBackend from 'i18next-locize-backend'
import Config from '../config'
import { isDevelopment, isServer } from '../utils/platform'
import resources from '../static/locales'
// Locize is able to fetch translations only if projectId is present
// apiKey and referenceLng params are required for app to add missing keys to localize
const locizeBackendOptions = {
  apiKey: Config.LOCIZE_API_KEY,
  projectId: Config.LOCIZE_PROJECT_ID,
  loadPath: `${Config.LOCIZE_PRIVATE_URL}/${Config.LOCIZE_PROJECT_ID}/latest/{{lng}}/{{ns}}`,
  fallbackLng: 'en',
  customHeaders: {
    'Cache-Control': 'max-age=0',
  },
}

const use = []
if (isServer()) {
  // Must be required with eval. Doesn't work without it
  const i18nextNodeLocizeBackend = eval("require('i18next-node-locize-backend')")
  use.push(i18nextNodeLocizeBackend)
} else {
  use.push(i18nextLocizeBackend)
}

const DETECTION_OPTIONS = {
  // order and from where user language should be detected
  order: ['navigator'],
}
// const DETECTION_OPTIONS = {
//   // order and from where user language should be detected
//   order: ['navigator', 'cookie', 'localStorage'],
//   caches: ['localStorage', 'cookie'],
//   lookupCookie: 'i18next',
//   lookupLocalStorage: 'i18nextLng',
// }

// NOTE: Before changing namespaces read docs/i18n
export const nextI18Next = new NextI18Next({
  serverLanguageDetection: false,
  detection: DETECTION_OPTIONS,
  load: 'languageOnly',
  defaultLanguage: 'pl',
  fallbackLng: 'en',
  otherLanguages: ['en', 'pl', 'uk'],
  use,
  backend: locizeBackendOptions,
  debug: false,
  // debug: Config.I18N_DEBUG === 'true',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
})

/* Optionally, export class methods as named exports */
export const { appWithTranslation, withTranslation, i18n } = nextI18Next

i18n.addResourceBundle('en', 'common', resources['en'].common)
i18n.addResourceBundle('pl', 'common', resources['pl'].common)
i18n.addResourceBundle('uk', 'common', resources['uk'].common)

export type WithTranslation = WithTranslationType
